import Dashboard from "views/Dashboard/Dashboard.jsx";
import Campaigns from "views/Campaigns/Campaigns.jsx";
import FileUpload from "views/FileUpload/FileUpload.jsx";
import Kickbox from "views/Kickbox/Kickbox.jsx";
import ViewAudiences from "views/Audiences/ViewAudiences.jsx";
import Resources from "../views/Resources/Resources.jsx";
import DataSources from "../views/Resources/DataSources.jsx";
import ViewLists from "../views/Lists/ViewLists.jsx";
import ViewAutomations from "../views/Automations/ViewAutomations.jsx";

// @material-ui/icons
import DashboardIcon from "@material-ui/icons/Dashboard";
import CryptoJS from "crypto-js";
// import ContentPaste from "@material-ui/icons/ContentPaste";
import HearingIcon from "@material-ui/icons/Hearing";
import FaceIcon from "@material-ui/icons/Face";
import ViewList from "@material-ui/icons/ViewList";
import UpdateIcon from "@material-ui/icons/Update";
import NearMe from "@material-ui/icons/NearMe";
import DataUsageIcon from "@material-ui/icons/DataUsage";
import RoomIcon from "@material-ui/icons/Room";
import SwitchCameraIcon from "@material-ui/icons/SwitchCamera";
import InsertChartIcon from "@material-ui/icons/InsertChart";
import UploadFileIcon from "@material-ui/icons/Unarchive";

import DateRange from "@material-ui/icons/DateRange";
import Calendar from "views/Calendar/Calendar.jsx";
import CustomerPortfolio from "../views/Insights/CustomerPortfolio";
import PowerBiDashboard from '../components/PowerBiInsights/powerBiDashboard'
import ViewDeliveries from "../views/Deliveries/ViewDeliveries.jsx";
import ViewMaps from "../views/Maps/ViewMaps.jsx";
import QueryTool from "../views/QueryTool/QueryTool.jsx";
import ChatIcon from "@material-ui/icons/Chat";
import ChatPage from "../views/ChatPage/ChatPage.jsx";
import AudienceBuilder from "../views/AudienceBuilder/audienceBuilder.jsx";
import HtmlReport from "../views/HtmlReporting/htmlReport.jsx";

var dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: DashboardIcon,
    component: Dashboard,
  },
  {
    redirect: true,
    path: "/dashboard",
    pathTo: "/dashboard",
    name: "Dashboard",
  },
  /*{
    path: "/campaigns",
    name: "Campaigns",
    icon: SwitchCameraIcon,
    component: Campaigns
  },
  {
    path: "/kickbox",
    name: "Kickbox",
    icon: SwitchCameraIcon,
    component: Kickbox
  },*/
  {
    path: "/audiences",
    name: "Audiences",
    icon: FaceIcon,
    component: ViewAudiences,
  },
  {
    path: "/build-audience",
    name: "Build Audience",
    icon: FaceIcon,
    component: AudienceBuilder,
    isHidden: true
  },
  {
    path: "/lists",
    name: "Lists",
    icon: ViewList,
    component: ViewLists,
  },
  {
    path: "/automations",
    name: "Automations",
    icon: UpdateIcon,
    component: ViewAutomations,
  },
  {
    path: "/deliveries",
    name: "Deliveries",
    icon: NearMe,
    component: ViewDeliveries,
  },
  {
    path: "/querytool",
    name: "Query Tool",
    icon: DataUsageIcon,
    component: QueryTool,
  },
  {
    path: "/maps",
    name: "Maps",
    icon: RoomIcon,
    component: ViewMaps,
  },
  {
    path: "/upload",
    name: "File Upload",
    icon: UploadFileIcon,
    component: FileUpload,
  },
  {
    path: "/ask-ai",
    name: "Ask AI",
    icon: ChatIcon,
    component: ChatPage,
  },
  /*{
    path: "/allresources",
    name: "Resource",
    icon: SwitchCameraIcon,
    component: Resources
  },*/
  /*{
    isresource: true,
    collapse: true,
    path: "/resources",
    name: "Resources",
    state: "openResources",
    icon: SwitchCameraIcon,
    views: [
      {
        path: "/resources/datasources",
        name: "Data Sources",
        mini: "DS",
        component: DataSources
      },
      {
        path: "/resources/dataprocessing",
        name: "Data Processing",
        mini: "DP",
        component: DataSources
      },
      {
        path: "/resources/rules",
        name: "Rules",
        mini: "RS",
        component: DataSources
      },
      {
        path: "/resources/datamodel",
        name: "Data Model",
        mini: "DM",
        component: DataSources
      },
      {
        path: "/resources/stmap",
        name: "Source-to-Target Mapping",
        mini: "STM",
        component: DataSources
      },
      {
        path: "/resources/glossary",
        name: "Field Glossary",
        mini: "FG",
        component: DataSources
      }
    ]
  },*/

  /*{
    path: "/calendar",
    name: "Marketing Calendar",
    icon: DateRange,
    component: Calendar
  },*/
  /*{
    path: "/querybuilder",
    name: "Custom Query Builder",
    icon: HearingIcon,
    component: CustomQueryBuilder
  }*/
  // {
  //   path: "/querybuilderStyles",
  //   name: "Custom Query Builder Styles",
  //   icon: HearingIcon,
  //   component: CustomQueryBuilderStyles
  // }
];

let tempvalues = [];
if (localStorage.getItem("licensedModules") != null) {
  if (
    JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem("licensedModules"),
        process.env.REACT_APP_PASS
      ).toString(CryptoJS.enc.Utf8)
    ) != null
  ) {
    tempvalues = JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem("licensedModules"),
        process.env.REACT_APP_PASS
      ).toString(CryptoJS.enc.Utf8)
    );
  }
}
tempvalues.push("File Upload");
let finaldashboardRoutes = [];
for (let i in dashboardRoutes) {
  if (tempvalues.includes(dashboardRoutes[i]["path"].substring(1))) {
    finaldashboardRoutes.push(dashboardRoutes[i]);
  }
}
dashboardRoutes = finaldashboardRoutes;
if (tempvalues.includes("insights")) {
  var appsData = {
    collapse: true,
    path: "/insights",
    name: "Insights",
    state: "openInsights",
    icon: InsertChartIcon,
    views: [],
  };

  // === EMBEDDED HTML REPORT ===
  let htmlReportingConfig = window.sessionStorage.getItem('html-reporting-insights')
  if (htmlReportingConfig) {
    let htmlReportData = JSON.parse(htmlReportingConfig)
    if (htmlReportData.hasOwnProperty('insights')) {
      for(let reportName of htmlReportData.insights) {
        appsData.views.push({
          path: "/insights/customerportfolio/" + reportName,
          name: reportName.replace('_',' '),
          mini: reportName.substring(0, 2),
          component: HtmlReport,
          id: reportName,
        });
      }
    }
  }

  // ==== POWER BI Integration ====
  if (localStorage.getItem("powerBiInsights") !== null && localStorage.getItem("powerBiInsights") !== undefined) {
    let powerBiInsights = JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem("powerBiInsights"),
        process.env.REACT_APP_PASS
      ).toString(CryptoJS.enc.Utf8)
    );

    for (let idx in powerBiInsights.reports.value) {
      if (
        !(powerBiInsights.reports.value[idx]['name'].match(/^Master Dataset.*/)) 
        && !(powerBiInsights.reports.value[idx]['name'].match(/^ *Dashboard */))
      ) {
        appsData.views.push({
          path: "/insights/customerportfolio/" + powerBiInsights.reports.value[idx]['name'].replace(' ', '-'),
          name: powerBiInsights.reports.value[idx]['name'],
          mini: powerBiInsights.reports.value[idx]['name'].substring(0, 2),
          component: PowerBiDashboard,
          id: powerBiInsights.reports.value[idx]['id'],
        });
      }
    }
  }
  // ==== QLIK ====
  if (localStorage.getItem("appData")) {
    let appData = [];
    if (localStorage.getItem("appData") != null) {
      appData =
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("appData"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) || [];
    }
    let appLength = Object.keys(appData).length;
    let count = 0;
    let appCount = 0;
    for (let app in appData) {
      appCount = appCount + 1;
      appsData.views.push({
        path: "/insights/customerportfolio/" + appData[app].replace(" ", "-"),
        name: appData[app],
        mini: appData[app].substring(0, 2),
        component: CustomerPortfolio,
        id: app,
      });
      count = count + 1;
    }
  }

  // Sort in Alp Order
  appsData.views.sort((a,b)=>{
    if (a.name < b.name) {
      return -1;
    }
    if (a.name > b.name) {
      return 1;
    }
    return 0;
  })

  dashboardRoutes = dashboardRoutes.concat(appsData);
}
export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx